export default {"src":"/_next/static/media/Happitu-Logo-horiz.64ec5c06.svg","height":43,"width":160,"blurWidth":0,"blurHeight":0};